import cartControlsHtml from './cartcontrols.component.html';
import './cartcontrols.component.scss';

class CartControlsController {
    constructor($scope, $location, $window, CartService, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$location = $location;
        this.$window = $window;
        this.service = CartService;
        this.SnackbarService = SnackbarService;
    }

    submit() {
        this.service.finalizeOrder().then(
            () => {
                this.step = 3;
                this.service.step = 3;
                this.service.load();
                this.$window.scrollTo(0, 0);

                let segments = this.$location.path().split('/');

                segments[segments.length - 1] = 'potwierdzenie';

                this.$location.path(segments.join('/'));

                if (typeof window.gtag === 'undefined') {
                    return;
                }

                console.log(`gtag::event::purchase -> zakup`);

                let eventPurchaseItems = [];
                for (const cartItem of this.service.items) {
                    eventPurchaseItems.push({
                        'id': cartItem.product_code,
                        'name': cartItem.name + (cartItem.variant_name ? ` - (${cartItem.variant_name})` : ''),
                        'quantity': cartItem.quantity,
                        'price': cartItem.price_gros
                    });
                }

                gtag('event', 'purchase', {
                    'transaction_id': this.service.orderId,
                    'affiliation': 'Rowery-Koga.pl',
                    'value': this.service.summary.amount_to_pay, // pełna kwota brutto (z kosztami wysyłki)
                    'currency': 'PLN',
                    'tax': this.service.summary.tax_amount_to_pay, // kwota podatku
                    'shipping': this.service.summary.value_of_shipment, // koszty wysyłki brutto
                    'items': eventPurchaseItems
                });
            }
        );
    }

    submitWithError() {
        this.service.showAllErrors = true;

        if (!this.service.data.acceptTerms) {
            if (Object.keys(this.service.stepTwoValidationErrors).length === 1 && this.service.stepTwoValidationErrors.acceptTerms) {
                this.SnackbarService.add('Prosimy o zaakceptowanie regulaminu.', 'error', true, 3000);
            } else {
                this.SnackbarService.add('Prosimy o poprawienie błędów w formularzu.', 'error', true, 3000);
            }
        }
    }
}

let cartControlsComponent = {
    bindings: {
        step: '<'
    },
    template: cartControlsHtml,
    controller: CartControlsController
}

export default cartControlsComponent;